import React from 'react';
import tokenIcon from '../assets/duck-token.png';
import '../styles/DailyTokenModal.css';

export default function DailyTokenModal({ isOpen, nextEligibleAt, onClose }) {
	if (!isOpen) return null;

	const nextLabel = nextEligibleAt ? new Date(nextEligibleAt).toLocaleString() : null;

	return (
		<div className="modal-overlay">
			<div className="modal-content daily-token-modal" role="dialog" aria-modal="true" aria-labelledby="daily-token-title">
				<div className="daily-token-burst" aria-hidden="true" />
				<h3 className="daily-token-title" id="daily-token-title">Congratulations!</h3>
				<p className="daily-token-subtitle">You earned a free Duck Token.</p>
				<div className="daily-token-chip" aria-hidden="true">
					<img src={tokenIcon} alt="" className="daily-token-icon" />
					<span>+1 Token</span>
				</div>
				{nextLabel ? (
					<p className="daily-token-next">Next free token available after {nextLabel}.</p>
				) : (
					<p className="daily-token-next">Come back tomorrow for another free token.</p>
				)}
				<div className="daily-token-actions">
					<button className="btn btn-orange" onClick={onClose}>Awesome!</button>
				</div>
			</div>
		</div>
	);
}
